import Icons from "../common/Icons";

export const CancelWarning = ({
  isOpen,
  active,
  navigate,
  items,
  setActive,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="font-[Afacad Flux] fixed inset-0 flex justify-center items-center z-50 p-4">
      {/* Backdrop with blur */}
      <div
        className="absolute inset-0"
        style={{
          background: "rgba(13, 21, 38, 0.85)",
          backdropFilter: "blur(8px)",
        }}
        onClick={() => {
          onClose();
          setActive(7);
        }}
      />

      {/* Modal */}
      <div
        className="relative overflow-hidden rounded-2xl max-w-lg w-full"
        style={{
          background:
            "linear-gradient(135deg, rgba(19, 32, 57, 0.98) 0%, rgba(13, 21, 38, 0.99) 100%)",
          border: "1px solid rgba(255, 90, 95, 0.2)",
          boxShadow:
            "0 24px 80px rgba(0, 0, 0, 0.5), 0 0 40px rgba(255, 90, 95, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
        }}
      >
        {/* Ambient glow - top */}
        <div
          className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-32 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse, rgba(255, 90, 95, 0.15) 0%, transparent 70%)",
            filter: "blur(20px)",
          }}
        />

        {/* Close button */}
        <button
          type="button"
          onClick={() => {
            onClose();
            setActive(7);
          }}
          className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-white/10 z-20"
          style={{
            background: "rgba(255, 255, 255, 0.05)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <span className="text-[#B4C1E4] text-xl leading-none">&times;</span>
        </button>

        {/* Content */}
        <div className="relative z-10 px-8 pt-12 pb-8">
          {/* Warning Icon */}
          <div className="flex justify-center mb-6">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center"
              style={{
                background:
                  "linear-gradient(135deg, rgba(255, 90, 95, 0.2) 0%, rgba(255, 90, 95, 0.1) 100%)",
                border: "1px solid rgba(255, 90, 95, 0.3)",
                boxShadow: "0 0 30px rgba(255, 90, 95, 0.2)",
              }}
            >
              <Icons
                type="warning"
                width={32}
                height={32}
                className="text-persimmon"
              />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-white text-xl font-semibold text-center mb-3 uppercase tracking-wide">
            Leave without saving?
          </h2>

          {/* Description */}
          <p className="text-[#B4C1E4] text-sm text-center mb-8 max-w-sm mx-auto">
            Any changes you've made will be lost if you leave without saving.
          </p>

          {/* Actions */}
          <div className="flex items-center justify-between gap-4">
            <button
              type="button"
              onClick={() => {
                onClose();
                setActive(7);
              }}
              className="flex items-center gap-2 px-5 py-2.5 rounded-xl transition-all duration-200"
              style={{
                background: "rgba(171, 235, 247, 0.08)",
                border: "1px solid rgba(171, 235, 247, 0.15)",
              }}
            >
              <Icons type="leftArrow" width={16} height={16} color="#ABEBF7" />
              <span className="text-[#ABEBF7] font-medium text-sm uppercase tracking-wide">
                Go Back
              </span>
            </button>

            <button
              onClick={() => {
                const item = items?.find((i) => i.id === active);
                if (item?.path) {
                  setActive(active);
                  navigate(item.path);
                }
                onClose();
              }}
              className="flex items-center gap-2 px-5 py-2.5 rounded-xl transition-all duration-200"
              style={{
                background:
                  "linear-gradient(135deg, rgba(255, 90, 95, 0.2) 0%, rgba(255, 90, 95, 0.1) 100%)",
                border: "1px solid rgba(255, 90, 95, 0.3)",
              }}
            >
              <span className="text-persimmon font-medium text-sm uppercase tracking-wide">
                Leave Profile
              </span>
              <Icons type="rightArrowRed" width={16} height={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
